export class FileHandler {
    constructor() {}

    public createAndDownloadFile(blobParts: BlobPart[], options: {type: string, name: string}) {
        const blob = new Blob(blobParts,{type: options.type})
        const file = new File([blob], options.name)
        const url = URL.createObjectURL(file)

        const link = document.createElement('a')
        link.href = url
        link.download = file.name
        document.body.appendChild(link)
        link.click()

        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
    }
}
